function getQueryKey() {
    return ["react-query:use-user"];
}
export { getQueryKey };
